import { SectionItem } from "@hd/auth/types/section-item";
import { SILENT_REQUEST_HEADER_KEY } from "@hd/http-client/constants";
import httpClient from "@hd/http-client/http-client";
import { RootSectionDto } from "@hd/types/dto/auth/root-section.dto";
import { ListItemDto } from "@hd/types/dto/shared/list-item.dto";
import { useQuery } from "@tanstack/react-query";

const apiUrl = import.meta.env.VITE_HD_API_URL + "/users/me";

const fetchData = async () => {
  const result = await httpClient.get<{
    userId: string;
    username: string;
    userFullName: string;
    selectedGroup: ListItemDto;
    sections: RootSectionDto[];
    activeGroups: ListItemDto[];
    isMonoCompanyWithId: number;
    // activeCompanies: ListItemDto[];
    editUsersAndPermissions: boolean;
  }>(apiUrl, {
    headers: {
      [SILENT_REQUEST_HEADER_KEY]: "true",
    },
  });

  // const section = result.data.sections.find(
  //   (s) => s.sectionTypeName === "Configura"
  // );

  // // mock
  // section?.sections.push({
  //   sectionName: "Doory AI",
  //   sectionTypeName: "Configura",
  //   sectionTypePosition: 1,
  //   sectionTypeIcon: "fa-gear",
  //   sectionUrl: "doory-dashboard",
  //   childSections: [],
  //   sectionID: 99999,
  //   sectionPosition: 0,
  //   isNewFlag: true,
  //   sectionTypeID: 9999,
  // });

  const sections: SectionItem[] = result.data.sections
    .filter((s) => s.sectionTypeName !== "Settings")
    .sort((a, b) => (a.sectionTypePosition < b.sectionTypePosition ? -1 : 1))
    .map((r) => ({
      name: r.sectionTypeName,
      defaultCollapsed: r.sectionTypeName === "Sales",
      children: r.sections
        .sort((a, b) => (a.sectionPosition < b.sectionPosition ? -1 : 1))
        .map((s) => ({
          name: s.sectionName,
          path: s.sectionUrl,
          isNewBadge: s.isNewBadge,
          children: s.childSections
            .sort((a, b) => (a.position < b.position ? -1 : 1))
            .map((c) => ({
              name: c.name,
              path: c.url,
            })),
        })),
    }));

  // teoricamente dovrebbe farlo la API
  return {
    ...result.data,
    sections,
  };
};

export const meQueryKey = () => [apiUrl];

export const useMeQuery = () => {
  return useQuery({
    staleTime: 1000 * 60 * 30, // 30 minuti
    queryKey: meQueryKey(),
    queryFn: () => fetchData(),
  });
};
